import gradients, { IGradient } from './gradients';

export type { IGradient };
export default gradients;
